export default __webpack_public_path__ + "static/InfoSection1-73ee62d9c75afc80684fd0df19603126.png";